import "antd/dist/antd.css";
import React from "react";
import axios from "@/utils/myaxios";
import Cookie from "js-cookie";
import MD5 from "blueimp-md5";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import { Form, Icon, Input, Button, Cascader, Select, message } from "antd";

// 区号
const areaCodeList = [
    { en: "Taiwan, Province of China", zh: "台湾 ", locale: "TWN", code: "886" },
    { en: "Hong Kong", zh: "香港 ", locale: "HK", code: "852" },
    { en: "Macao", zh: "澳门", locale: "MAC", code: "853" },
    { en: "Albania", zh: "阿尔巴尼亚", locale: "AL", code: "355" },
    { en: "Algeria", zh: "阿尔及利亚", locale: "DZ", code: "213" },
    { en: "Afghanistan", zh: "阿富汗", locale: "AF", code: "93" },
    { en: "Argentina", zh: "阿根廷", locale: "AR", code: "54" },
    {
        en: "United Arab Emirates",
        zh: "阿拉伯联合酋长国",
        locale: "AE",
        code: "971",
    },
    { en: "Aruba", zh: "阿鲁巴 (荷兰王国)", locale: "NLD", code: "297" },
    { en: "Oman", zh: "阿曼", locale: "OM", code: "968" },
    { en: "Azerbaijan", zh: "阿塞拜疆", locale: "AZ", code: "994" },
    { en: "Ascension island", zh: "阿森松岛", locale: "UK", code: "247" },
    { en: "Egypt", zh: "埃及", locale: "EG", code: "20" },
    { en: "Ethiopia", zh: "埃塞俄比亚", locale: "ET", code: "251" },
    { en: "Ireland", zh: "爱尔兰共和国", locale: "IRL", code: "353" },
    { en: "Estonia", zh: "爱沙尼亚", locale: "EE", code: "372" },
    { en: "Andorra", zh: "安道尔", locale: "AD", code: "376" },
    { en: "Angola", zh: "安哥拉", locale: "AO", code: "244" },
    { en: "Anguilla", zh: "安圭拉", locale: "AI", code: "1264" },
    {
        en: "Antigua and Barbuda",
        zh: "安提瓜和巴布达",
        locale: "AG",
        code: "1268",
    },
    { en: "Austria", zh: "奥地利", locale: "AT", code: "43" },
    { en: "Australia", zh: "澳洲", locale: "AUS", code: "61" },
    { en: "Barbados", zh: "巴巴多斯", locale: "BRB", code: "1246" },
    { en: "Papua New Guinea", zh: "巴布亚新几内亚", locale: "PG", code: "675" },
    { en: "Bahamas", zh: "巴哈马", locale: "BHS", code: "1242" },
    { en: "Pakistan", zh: "巴基斯坦", locale: "PK", code: "92" },
    { en: "Paraguay", zh: "巴拉圭", locale: "PY", code: "595" },
    { en: "Palestine, State of", zh: "巴勒斯坦", locale: "BL", code: "930" },
    { en: "Bahrain", zh: "巴林", locale: "BH", code: "973" },
    { en: "Panama", zh: "巴拿马", locale: "PA", code: "507" },
    { en: "Brazil", zh: "巴西", locale: "BR", code: "55" },
    { en: "Belarus", zh: "白俄罗斯", locale: "BY", code: "375" },
    { en: "Bermuda", zh: "百慕大 (英国)", locale: "BM", code: "1441" },
    { en: "Bulgaria", zh: "保加利亚", locale: "BG", code: "359" },
    { en: "Benin", zh: "贝宁", locale: "BJ", code: "229" },
    { en: "Belgium", zh: "比利时", locale: "BE", code: "32" },
    { en: "Iceland", zh: "冰岛", locale: "IS", code: "354" },
    { en: "Puerto Rico", zh: "波多黎各 (美国)", locale: "PR", code: "1787" },
    { en: "Poland", zh: "波兰", locale: "PL", code: "48" },
    {
        en: "Bosnia and Herzegovina",
        zh: "波斯尼亚与赫塞哥维纳",
        locale: "BIH",
        code: "387",
    },
    { en: "Bolivia, Plurinational", zh: "玻利维亚", locale: "BO", code: "591" },
    { en: "Belize", zh: "伯利兹", locale: "BLZ", code: "501" },
    { en: "Botswana", zh: "博茨瓦纳", locale: "BW", code: "267" },
    {
        en: "Bonaire Sint Eustat",
        zh: "博内尔岛，圣尤斯特歇斯和",
        locale: "BSE",
        code: "599",
    },
    { en: "Bhutan", zh: "不丹", locale: "BTN", code: "975" },
    { en: "Burkina Faso", zh: "布基纳法索", locale: "BF", code: "226" },
    { en: "Burundi", zh: "布隆迪", locale: "BI", code: "257" },
    { en: "Chad", zh: "查德", locale: "TCD", code: "235" },
    { en: "Equatorial Guinea", zh: "赤道几内亚", locale: "GNQ", code: "240" },
    { en: "Denmark", zh: "丹麦", locale: "DK", code: "45" },
    { en: "Germany", zh: "德国", locale: "BRD", code: "49" },
    { en: "Timor ", zh: "东帝汶", locale: "TLS", code: "670" },
    { en: "Tonga", zh: "东加", locale: "TG", code: "676" },
    { en: "Togo", zh: "多哥", locale: "TG", code: "228" },
    {
        en: "Dominican Republic",
        zh: "多米尼加共和国",
        locale: "DO",
        code: "1809",
    },
    { en: "Dominica", zh: "多米尼克", locale: "DMA", code: "1767" },
    { en: "Russian Federation", zh: "俄罗斯", locale: "RU", code: "7" },
    { en: "Ecuador", zh: "厄瓜多尔", locale: "EC", code: "593" },
    { en: "France", zh: "法国", locale: "FR", code: "33" },
    { en: "Faroe Islands", zh: "法罗群岛 (丹麦)", locale: "FO", code: "298" },
    {
        en: "French Polynesia",
        zh: "法属波利尼西亚 (法国)",
        locale: "PF",
        code: "689",
    },
    { en: "French Guiana", zh: "法属圭亚那 (法国)", locale: "FRG", code: "594" },
    { en: "Philippines", zh: "菲律宾", locale: "PH", code: "63" },
    { en: "Fiji", zh: "斐济", locale: "FJ", code: "679" },
    { en: "Finland", zh: "芬兰", locale: "FI", code: "358" },
    { en: "Cape Verde", zh: "佛得角", locale: "CPV", code: "238" },
    { en: "Gambia", zh: "冈比亚", locale: "GMB", code: "220" },
    {
        en: "Congo, the Democratic Republic of the",
        zh: "刚果民主共和国",
        locale: "COD",
        code: "243",
    },
    { en: "Congo", zh: "刚果共和国", locale: "COG", code: "242" },
    { en: "Colombia", zh: "哥伦比亚", locale: "CO", code: "57" },
    { en: "Costa Rica", zh: "哥斯达黎加", locale: "CR", code: "506" },
    { en: "Grenada", zh: "格林纳达", locale: "GD", code: "1473" },
    { en: "Greenland", zh: "格陵兰 (丹麦)", locale: "GL", code: "299" },
    { en: "Cuba", zh: "古巴", locale: "CU", code: "53" },
    { en: "Guadeloupe", zh: "瓜德罗普岛", locale: "GDL", code: "590" },
    { en: "Guam", zh: "关岛 (美国)", locale: "GU", code: "1671" },
    { en: "Guyana", zh: "圭亚那", locale: "GUY", code: "592" },
    { en: "Kazakhstan", zh: "哈萨克", locale: "KZ", code: "7" },
    { en: "Haiti", zh: "海地", locale: "HT", code: "509" },
    { en: "Korea, Republic of", zh: "韩国", locale: "KR", code: "82" },
    { en: "Netherlands", zh: "荷兰", locale: "NL", code: "31" },
    { en: "Montenegro", zh: "黑山共和国", locale: "MNE", code: "382" },
    { en: "Honduras", zh: "洪都拉斯", locale: "HN", code: "504" },
    { en: "Kiribati", zh: "基里巴斯", locale: "KIR", code: "686" },
    { en: "Djibouti", zh: "吉布提", locale: "DJI", code: "253" },
    { en: "Kyrgyzstan", zh: "吉尔吉斯", locale: "KGZ", code: "996" },
    { en: "Guinea", zh: "几内亚", locale: "GN", code: "224" },
    { en: "Guinea ", zh: "几内亚比绍", locale: "GNB", code: "245" },
    { en: "Canada", zh: "加拿大", locale: "CA", code: "1" },
    { en: "Ghana", zh: "加纳", locale: "GH", code: "233" },
    { en: "Gabon", zh: "加蓬", locale: "GA", code: "241" },
    { en: "Cambodia", zh: "柬埔寨", locale: "KH", code: "855" },
    { en: "Czech Republic", zh: "捷克", locale: "CS", code: "420" },
    { en: "Republic of Zimbabwe", zh: "津巴布韦", locale: "ZW", code: "263" },
    { en: "Cameroon", zh: "喀麦隆", locale: "CM", code: "237" },
    { en: "Qatar", zh: "卡达", locale: "QAT", code: "974" },
    { en: "Cayman Islands", zh: "开曼群岛 (英国)", locale: "CYM", code: "1345" },
    { en: "Comoros", zh: "科摩罗", locale: "COM", code: "269" },
    { en: "Côte d'Ivoire", zh: "科特迪瓦", locale: "CIV", code: "225" },
    { en: "Kuwait", zh: "科威特", locale: "KW", code: "965" },
    { en: "Croatia", zh: "克罗地亚", locale: "HRV", code: "385" },
    { en: "Kenya", zh: "肯尼亚", locale: "KEN", code: "254" },
    { en: "Cook Islands", zh: "库克群岛 (新西兰)", locale: "COK", code: "682" },
    { en: "Curacao", zh: "库拉索 (荷兰王国)", locale: "NLD", code: "599" },
    { en: "Latvia", zh: "拉脱维亚", locale: "LV", code: "371" },
    { en: "Lesotho", zh: "莱索托", locale: "LSO", code: "266" },
    {
        en: "Lao People's Democratic Republic",
        zh: "老挝",
        locale: "LA",
        code: "856",
    },
    { en: "Lebanon", zh: "黎巴嫩", locale: "LB", code: "961" },
    { en: "Lithuania", zh: "立陶宛", locale: "LT", code: "370" },
    { en: "Liberia", zh: "利比里亚", locale: "LR", code: "231" },
    { en: "Libya", zh: "利比亚", locale: "LY", code: "218" },
    { en: "Liechtenstein", zh: "列支敦士登", locale: "LI", code: "423" },
    { en: "Réunion", zh: "留尼汪 (法国)", locale: "FR", code: "262" },
    { en: "Luxembourg", zh: "卢森堡", locale: "LU", code: "352" },
    { en: "Rwanda", zh: "卢旺达", locale: "RWA", code: "250" },
    { en: "Romania", zh: "罗马尼亚", locale: "RO", code: "40" },
    { en: "Madagascar", zh: "马达加斯加", locale: "MG", code: "261" },
    { en: "Maldives", zh: "马尔代夫", locale: "MDV", code: "960" },
    { en: "Malta", zh: "马耳他", locale: "MT", code: "356" },
    { en: "Malawi", zh: "马拉维", locale: "MW", code: "265" },
    { en: "Malaysia", zh: "马来西亚", locale: "MY", code: "60" },
    { en: "Mali", zh: "马里共和国", locale: "MLI", code: "223" },
    {
        en: "Macedonia, the former Yugoslav Republic of",
        zh: "马其顿",
        locale: "MKD",
        code: "389",
    },
    { en: "Martinique", zh: "马提尼克 (法国)", locale: "MTQ", code: "596" },
    { en: "Mayotte", zh: "马约特", locale: "MYT", code: "269" },
    { en: "Mauritius", zh: "毛里求斯", locale: "MU", code: "230" },
    { en: "Mauritania", zh: "毛里塔尼亚", locale: "MRT", code: "222" },
    { en: "United States", zh: "美国", locale: "US", code: "1" },
    {
        en: "American Samoa",
        zh: "美属萨摩亚 (美国)",
        locale: "ESA",
        code: "1684",
    },
    {
        en: "United States Virgin Islands",
        zh: "美属维尔京群岛 (美国)",
        locale: "VI",
        code: "1340",
    },
    { en: "Mongolia", zh: "蒙古国", locale: "MNG", code: "976" },
    { en: "Montserrat", zh: "蒙塞拉特岛 (英国)", locale: "MS", code: "1664" },
    { en: "Bangladesh", zh: "孟加拉国", locale: "BGD", code: "880" },
    { en: "Peru", zh: "秘鲁", locale: "PE", code: "51" },
    { en: "Myanmar", zh: "缅甸", locale: "MM", code: "95" },
    { en: "Moldova, Republic of", zh: "摩尔多瓦", locale: "MD", code: "373" },
    { en: "Morocco", zh: "摩洛哥", locale: "MA", code: "212" },
    { en: "Monaco", zh: "摩纳哥", locale: "MC", code: "377" },
    { en: "Mozambique", zh: "莫桑比克", locale: "MZ", code: "258" },
    { en: "Mexico", zh: "墨西哥", locale: "MX", code: "52" },
    { en: "Namibia", zh: "纳米比亚", locale: "NA", code: "264" },
    { en: "South Africa", zh: "南非", locale: "ZA", code: "27" },
    { en: "South Sudan", zh: "南苏丹", locale: "SSD", code: "211" },
    { en: "Nicaragua", zh: "尼加拉瓜", locale: "NI", code: "505" },
    { en: "Nepal", zh: "尼泊尔", locale: "NP", code: "977" },
    { en: "Niger", zh: "尼日", locale: "NER", code: "227" },
    { en: "Nigeria", zh: "尼日利亚", locale: "NG", code: "234" },
    { en: "Norway", zh: "挪威", locale: "NO", code: "47" },
    { en: "Palau", zh: "帕劳", locale: "PLW", code: "680" },
    { en: "Portugal", zh: "葡萄牙", locale: "PT", code: "351" },
    { en: "Georgia", zh: "乔治亚", locale: "GEO", code: "995" },
    { en: "Japan", zh: "日本", locale: "JP", code: "81" },
    { en: "Sweden", zh: "瑞典", locale: "SE", code: "46" },
    { en: "Switzerland", zh: "瑞士", locale: "CH", code: "41" },
    { en: "El Salvador", zh: "萨尔瓦多", locale: "SLV", code: "503" },
    { en: "Samoa", zh: "萨摩亚", locale: "WSM", code: "685" },
    { en: "Serbia", zh: "塞尔维亚共和国", locale: "SRB", code: "381" },
    { en: "Senegal", zh: "塞内加尔", locale: "SN", code: "221" },
    { en: "Cyprus", zh: "塞浦路斯", locale: "CY", code: "357" },
    { en: "Seychelles", zh: "塞舌尔", locale: "SC", code: "248" },
    { en: "Saudi Arabia", zh: "沙特阿拉伯", locale: "SA", code: "966" },
    {
        en: "Sao Tome and Principe",
        zh: "圣多美普林西比",
        locale: "STP",
        code: "239",
    },
    {
        en: "Saint Kitts and Nevis",
        zh: "圣克里斯多福与尼维斯",
        locale: "KNA",
        code: "1869",
    },
    { en: "Saint Lucia", zh: "圣卢西亚", locale: "LC", code: "1758" },
    {
        en: "Sint Maarten(Dutch)",
        zh: "圣马丁岛(荷兰部分)",
        locale: "NL",
        code: "590",
    },
    { en: "San Marino", zh: "圣马力诺", locale: "SM", code: "378" },
    {
        en: "Saint Pierre and Miquelon",
        zh: "圣皮耶与密克隆群岛 (法国)",
        locale: "FR",
        code: "508",
    },
    {
        en: "Saint Vincent and the Grenadines",
        zh: "圣文森及格林纳丁",
        locale: "VCT",
        code: "1784",
    },
    { en: "Sierra Leone", zh: "狮子山共和国", locale: "SLE", code: "232" },
    { en: "Sri Lanka", zh: "斯里兰卡", locale: "LK", code: "94" },
    { en: "Slovakia", zh: "斯洛伐克", locale: "SK", code: "421" },
    { en: "Slovenia", zh: "斯洛文尼亚", locale: "SI", code: "386" },
    { en: "Swaziland", zh: "斯威士兰", locale: "SZ", code: "268" },
    { en: "Sudan", zh: "苏丹", locale: "SD", code: "249" },
    { en: "Suriname", zh: "苏里南", locale: "SUR", code: "597" },
    { en: "Solomon Islands", zh: "所罗门群岛", locale: "SLB", code: "677" },
    { en: "Somalia", zh: "索马里", locale: "SO", code: "252" },
    { en: "Tajikistan", zh: "塔吉克", locale: "TJK", code: "992" },
    { en: "Thailand", zh: "泰国", locale: "TH", code: "66" },
    {
        en: "Tanzania, United Republic of",
        zh: "坦桑尼亚",
        locale: "TZ",
        code: "255",
    },
    {
        en: "Trinidad and Tobago",
        zh: "特立尼达和多巴哥",
        locale: "TTO",
        code: "1868",
    },
    { en: "Tunisia", zh: "突尼斯", locale: "TN", code: "216" },
    { en: "Turkey", zh: "土耳其", locale: "TR", code: "90" },
    {
        en: "Turks and Caicos Islands",
        zh: "土克凯可群岛 (英国)",
        locale: "TC",
        code: "1649",
    },
    { en: "Turkmenistan", zh: "土库曼", locale: "TM", code: "993" },
    { en: "Vanuatu", zh: "瓦努阿图", locale: "TLS", code: "678" },
    { en: "Guatemala", zh: "危地马拉", locale: "GT", code: "502" },
    {
        en: "Venezuela, Bolivarian Republic of",
        zh: "委内瑞拉",
        locale: "VE",
        code: "58",
    },
    { en: "Brunei Darussalam", zh: "文莱", locale: "BN", code: "673" },
    { en: "Uganda", zh: "乌干达", locale: "UG", code: "256" },
    { en: "Ukraine", zh: "乌克兰", locale: "UA", code: "380" },
    { en: "Uruguay", zh: "乌拉圭", locale: "UY", code: "598" },
    { en: "Uzbekistan", zh: "乌兹别克", locale: "UZ", code: "998" },
    { en: "Spain", zh: "西班牙", locale: "ES", code: "34" },
    { en: "Greece", zh: "希腊", locale: "GR", code: "30" },
    { en: "Singapore", zh: "新加坡", locale: "SG", code: "65" },
    {
        en: "New Caledonia",
        zh: "新喀里多尼亚 (法国)",
        locale: "NCL",
        code: "687",
    },
    { en: "New Zealand", zh: "新西兰", locale: "NZ", code: "64" },
    { en: "Hungary", zh: "匈牙利", locale: "HU", code: "36" },
    { en: "Syrian Arab Republic", zh: "叙利亚", locale: "SY", code: "963" },
    { en: "Jamaica", zh: "牙买加", locale: "JM", code: "1876" },
    { en: "Armenia", zh: "亚美尼亚", locale: "AM", code: "374" },
    { en: "Yemen", zh: "也门", locale: "YE", code: "967" },
    { en: "Iraq", zh: "伊拉克", locale: "IQ", code: "964" },
    { en: "Iran, Islamic Republic of", zh: "伊朗", locale: "IR", code: "98" },
    { en: "Israel", zh: "以色列", locale: "IL", code: "972" },
    { en: "Italy", zh: "意大利", locale: "IT", code: "39" },
    { en: "India", zh: "印度", locale: "IN", code: "91" },
    { en: "Indonesia", zh: "印度尼西亚", locale: "ID", code: "62" },
    { en: "United Kingdom", zh: "英国", locale: "UK", code: "44" },
    {
        en: "Virgin Islands, U.S.",
        zh: "英属维尔京群岛 (英国)",
        locale: "VG",
        code: "1284",
    },
    { en: "Jordan", zh: "约旦", locale: "JO", code: "962" },
    { en: "Vietnam", zh: "越南", locale: "VN", code: "84" },
    { en: "Zambia", zh: "赞比亚", locale: "ZM", code: "260" },
    { en: "Gibraltar", zh: "直布罗陀 (英国)", locale: "GI", code: "350" },
    { en: "Chile", zh: "智利", locale: "CL", code: "56" },
    {
        en: "Central African Republic",
        zh: "中非共和国",
        locale: "CAF",
        code: "236",
    },
    { en: "China", zh: "中国", locale: "CN", code: "86" },
];

const WrappedLoginForm = Form.create({ name: "normal_login" })(
    class LoginForm extends React.Component {
        state = {
            loading: false, // 登录中
            showSelectAccount: false, // 是否显示选择超盟联/盟账号表单
            loginType: "mobile", // 登陆类型
            areacode: "886", // 手机区号
            superUnionList: [], // 超盟列表
        };

        /**
         * 获取超盟列表
         */
        fetchSuperUnionList = () => {
            axios.get("/v1/api/vip/super_union_tree_list").then((res) => {
                res.data = res.data || [];
                res.data.forEach((item) => {
                    item.label = `${item.super_union_name}(${item.super_union_id})`;
                    item.value = item.super_union_id;
                    if (item.union_list && item.union_list.length > 0) {
                        item.union_list.forEach((item2) => {
                            item2.label = `${item2.union_name}(${item2.union_id})`;
                            item2.value = item2.union_id;
                        });
                        item.children = item.union_list;
                    }
                });
                this.setState({ superUnionList: res.data });
            });
        };

        /**
         * 登陆
         */
        handleSubmit = () => {
            this.props.form.validateFields((err, { account, password }) => {
                if (!err) {
                    this.setState({ loading: true });
                    axios
                        .post("/union_login", {
                            areacode:
                                this.state.loginType === "mobile"
                                    ? "+" + this.state.areacode
                                    : undefined,
                            account,
                            password: MD5(password + "0PQy5IK1#XcMoCWx"),
                        })
                        .then((res) => {
                            this.setState({ loading: false });
                            if (res.code === 1) {
                                const result = res.data;
                                if (result.identity === "vip") {
                                    // 超级账号
                                    Cookie.set("token", result.token, { expires: 0.1 });
                                    this.setState({ showSelectAccount: true });
                                    this.fetchSuperUnionList();
                                } else {
                                    // 普通账号
                                    Cookie.set("token", result.token, { expires: 0.1 });
                                    Cookie.set("identityType", result.identity, { expires: 0.1 });
                                    Cookie.set("name", result.name, { expires: 0.1 });
                                    Cookie.set("account", result.account, { expires: 0.1 });
                                    Cookie.set("allowCreate", result.allow_create, { expires: 0.1 });
                                    Cookie.set("isKpoker", result.is_kpoker, { expires: 0.1 });
                                    Cookie.set("isAce1", result.is_ace1, { expires: 0.1 });
                                    window.location.href = "/";
                                }
                            } else {
                                message.error(res.msg);
                            }
                        });
                }
            });
        };

        /**
         * 切换账号
         */
        handleSwithAccount = () => {
            this.props.form.validateFields((err, { ids }) => {
                if (!err) {
                    this.setState({ loading: true });
                    axios
                        .get("/v1/api/vip/switch_union", {
                            params: {
                                union_id: ids[ids.length - 1],
                            },
                        })
                        .then((res) => {
                            this.setState({ loading: false });
                            if (res.code === 1) {
                                const result = res.data;
                                Cookie.set("token", result.token, { expires: 0.1 });
                                Cookie.set("identityType", result.identity, { expires: 0.1 });
                                Cookie.set("name", result.name, { expires: 0.1 });
                                Cookie.set("account", result.account, { expires: 0.1 });
                                Cookie.set("allowCreate", result.allow_create, { expires: 0.1 });
                                Cookie.set("isKpoker", result.is_kpoker, { expires: 0.1 });
                                Cookie.set("isAce1", result.is_ace1, { expires: 0.1 });
                                window.location.href = "/";
                            }
                        });
                }
            });
        };

        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <div className="login">
                    <div className="content">
                        <h1 className="mb20">{this.props.language["loginTitle"]}</h1>

                        {/* 登录表单 */}
                        {!this.state.showSelectAccount && (
                            <Form style={{ width: 300 }}>
                                {/* 手机登录 */}
                                {this.state.loginType === "mobile" && (
                                    <Form.Item>
                                        {getFieldDecorator("account", {
                                            rules: [{ required: true, message: this.props.language["phoneAccountPlaceholder"] }],
                                        })(
                                            <Input
                                                prefix={<Icon type="mobile" />}
                                                addonBefore={
                                                    <Select
                                                        showSearch
                                                        optionFilterProp="children"
                                                        defaultValue={"+" + this.state.areacode}
                                                        style={{ width: 85 }}
                                                        onChange={(value) =>
                                                            this.setState({ areacode: value })
                                                        }
                                                    >
                                                        {areaCodeList.map((item, index) => (
                                                            <Select.Option key={item.code} value={item.code}>
                                                                +{item.code}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                }
                                                placeholder={this.props.language["phoneAccount"]}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 邮箱登录 */}
                                {this.state.loginType === "email" && (
                                    <Form.Item>
                                        {getFieldDecorator("account", {
                                            rules: [{ required: true, message: this.props.language["emailAccountPlaceholder"] }],
                                        })(
                                            <Input
                                                prefix={<Icon type="mail" />}
                                                placeholder={this.props.language["emailAccount"]}
                                            />
                                        )}
                                    </Form.Item>
                                )}

                                {/* 密码 */}
                                <Form.Item>
                                    {getFieldDecorator("password", {
                                        rules: [{ required: true, message: this.props.language["passwordPlaceholder"] }],
                                    })(
                                        <Input
                                            prefix={<Icon type="lock" />}
                                            type="password"
                                            placeholder={this.props.language["password"]}
                                        />
                                    )}
                                </Form.Item>

                                {/* 按钮 */}
                                <Form.Item>
                                    <Button
                                        style={{ width: "100%" }}
                                        type="primary"
                                        icon="login"
                                        loading={this.state.loading}
                                        onClick={this.handleSubmit}
                                    >
                                        {this.props.language["login"]}
                                    </Button>
                                    {this.state.loginType == "email" && (
                                        <Button
                                            style={{ width: "100%" }}
                                            icon="mobile"
                                            onClick={() => this.setState({ loginType: "mobile" })}
                                        >
                                            {this.props.language["phoneAccountLogin"]}
                                        </Button>
                                    )}
                                    {this.state.loginType == "mobile" && (
                                        <Button
                                            style={{ width: "100%" }}
                                            icon="mail"
                                            onClick={() => this.setState({ loginType: "email" })}
                                        >
                                            {this.props.language["emailAccountLogin"]}
                                        </Button>
                                    )}
                                </Form.Item>
                            </Form>
                        )}

                        {/* 选择超盟/联盟账号表单 */}
                        {this.state.showSelectAccount && (
                            <Form style={{ width: 300 }}>
                                <Form.Item>
                                    {getFieldDecorator("ids", {
                                        rules: [{ required: true, message: this.props.language["unionAccountPlaceholder"] }],
                                    })(
                                        <Cascader
                                            showSearch
                                            allowClear
                                            changeOnSelect
                                            options={this.state.superUnionList}
                                            placeholder={this.props.language["unionAccount"]}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        style={{ width: "100%" }}
                                        type="primary"
                                        icon="login"
                                        loading={this.state.loading}
                                        onClick={this.handleSwithAccount}
                                    >
                                        {this.props.language["confirm"]}
                                    </Button>
                                    <Button
                                        style={{ width: "100%" }}
                                        type="default"
                                        icon="step-backward"
                                        onClick={() => this.setState({ showSelectAccount: false })}
                                    >
                                        {this.props.language["lastStep"]}
                                    </Button>
                                </Form.Item>
                            </Form>
                        )}
                    </div>
                </div>
            );
        }
    }
);
export default class Login extends React.Component {
    render () {
        return <WrappedLoginForm {...this.props} />;
    }
}
